var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSidebarModulesActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B5A965D9-D51E-4783-86B6-8D927A793A11") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.3,2 C17.7911688,2 19,3.19390733 19,4.66666667 L19,15.3333333 C19,16.8060927 17.7911688,18 16.3,18 L3.7,18 C2.20883118,18 1,16.8060927 1,15.3333333 L1,4.66666667 C1,3.19390733 2.20883118,2 3.7,2 L16.3,2 Z M16.999,9 L3,9 L3,15 C3,15.5128358 3.38597235,15.9355353 3.88330648,15.9933367 L3.99996354,16.0000638 L15.9991251,16.0000638 C16.5513813,15.9999271 16.999198,15.5522563 16.999198,15 L16.999,9 Z M9.09237054,10.0848962 L12.6149086,11.8906303 C12.7394222,11.9544588 12.84175,12.0506275 12.9096665,12.1676464 C13.1050148,12.5042282 12.9730472,12.9259109 12.6149086,13.109501 L9.09237054,14.9152351 C8.98386964,14.9708551 8.86225312,15 8.7386611,15 C8.33070984,15 8,14.689196 8,14.3057998 L8,10.6943315 C8,10.5781787 8.03101148,10.4638824 8.09019379,10.3619123 C8.28554212,10.0253304 8.73423193,9.90130614 9.09237054,10.0848962 Z M3.00080203,5 L3,7 L5.26,7 L3.00212632,4.94829098 L3.00080203,5 Z M7.411,4 L4.04,4 L7.34,7 L10.411,7 L7.411,4 Z M12.411,4 L9.389,4 L12.389,7 L15.411,7 L12.411,4 Z M16,4 L14.389,4 L16.999,6.609 L16.9999271,5 C17.0000322,4.48716416 16.6140276,4.0644647 16.1166935,4.00666333 L16,4 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Apm\\u0101c\\u012Bbu-modu\\u013Ci",
    transform: "translate(-20.000000, -247.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu",
    transform: "translate(0.000000, 61.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 4,
    transform: "translate(0.000000, 176.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(20.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Sidebar-/-Modules",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "viewbox",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icon",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Icon-color",
    fill: "#0883EF",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSidebarModulesActive);
export default __webpack_public_path__ + "static/media/ic-sidebar-modules-active.6161b45e3075099442e295ac063f1c90.svg";
export { ForwardRef as ReactComponent };